import { ListInlineIconItem } from 'common/grid-list-items/list-inline-icon-item.js';
import { getSoilData } from 'components/map/marker-view/main/weatherStation/station-utils-soil.js';
import { IClothing, IWind } from 'types/location.js';
import { WeatherStationLocationType } from 'types/markerTypes/marker.weatherStation.js';
import { ILocationSummaryV1 } from 'types/markerTypesV1/marker-v1-view-type.js';
import { ensureString, isNotNullOrUndefined } from 'utilities/isType.js';

export const StationDescriptionWindObsItem = ({ wind }: { wind: Partial<IWind> | undefined }) => {
  if (wind) {
    const { strength, direction, averageSpeed } = wind;
    let avSpeed = ensureString(averageSpeed);

    if (avSpeed || typeof avSpeed === 'number') {
      avSpeed += 'km/h ';
    }

    return (
      <ListInlineIconItem title="Wind" v={1} icon="wind">
        <span>{`${ensureString(strength)} ${avSpeed}${ensureString(direction)}`}</span>
      </ListInlineIconItem>
    );
  }
  return null;
};

export const StationDescriptionClothingItem = ({ clothing }: { clothing: IClothing | undefined }) => {
  if (clothing) {
    const { layers, windproofLayers } = clothing;
    const layersText = `${layers} layer${layers > 0 ? 's' : ''}`;
    return (
      <ListInlineIconItem v={1} icon="clothing" title="Clothing">
        <span>{`${layersText}, ${windproofLayers} windproof`}</span>
      </ListInlineIconItem>
    );
  }
  return null;
};

export const StationDescriptionSoilMoistureItem = ({
  value,
}: {
  value: ILocationSummaryV1<WeatherStationLocationType>['value'];
}) => {
  const soilData = getSoilData(value);
  if (soilData) {
    const soilMoisture = soilData.moisture;
    if (isNotNullOrUndefined(soilMoisture)) {
      return (
        <ListInlineIconItem v={1} icon="soil-moisture" title="Soil Moisture">
          <span>{`${soilMoisture}%`}</span>
        </ListInlineIconItem>
      );
    }
  }
  return null;
};

export const StationDescriptionSoilTemperatureItem = ({
  value,
}: {
  value: ILocationSummaryV1<WeatherStationLocationType>['value'];
}) => {
  const soilData = getSoilData(value);
  if (soilData) {
    const temperature = soilData.temperature;
    if (isNotNullOrUndefined(temperature)) {
      return (
        <ListInlineIconItem v={1} icon="soil-temperature" title="Soil Temperature">
          <span>{`${temperature}°`}</span>
        </ListInlineIconItem>
      );
    }
  }
  return null;
};
